
import Vue from 'vue'
import CheckoutPage from './CheckoutPage.vue'

export default Vue.extend({
   name: 'StoreCheckoutApp',
   components: {
      CheckoutPage,
   },
   mounted() {
      this.$store.dispatch('loadModelData')
   },
})
